import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-profile',
  templateUrl: './employee-profile.component.html',
  styleUrls: ['./employee-profile.component.sass'],
})
export class EmployeeProfileComponent implements OnInit {
  userfirstname: string | undefined;
  userlastname: string | undefined;
  username: string | undefined;
  usermail: string | undefined;

  constructor() {}
  ngOnInit(): void {
    this.getemployeename();
  }

  async getemployeename() {
    // this.userfirstname = (await this.keycloak.loadUserProfile()).firstName;
    // this.userlastname = (await this.keycloak.loadUserProfile()).lastName;
    // this.usermail = (await this.keycloak.loadUserProfile()).email;
  }
}
